module.exports = __webpack_public_path__ + "static/media/hotelPagePlayareaIcon.80c1ac4b.png";